module.exports = __webpack_public_path__ + "img/valentine-dark-medium.56a7ded0.svg";